import React, { useEffect, useRef, useState } from "react";
import {
  // Alert,
  Card,
  Col,
  Container,
  Row,
  // Table,
  Button,
  // Spinner,
} from "reactstrap";
import EventsListScreenHeader from "../components/Headers/EventsListScreenHeader";
import Paper from "@material-ui/core/Paper";
import { BiArrowBack, BiChevronRight, BiChevronLeft } from "react-icons/bi";
import { FiShare } from "react-icons/fi";
import { useHistory, useLocation } from "react-router-dom";
// import { useModal } from "../utils/useModal";
import axiosClient from "../utils/axiosClient";
import useMessages from "../utils/useMessages";
import type { ChangeEvent } from "react";
import { RenderConversations } from "../components/Conversations/RenderConversations";
import { response } from "../../src/types";
import { FetchingResults } from "../components/FetchingResults";
import { BsArrowUpCircle } from "react-icons/bs";
import { PdfFocusProvider } from "../../src/context/pdf";
import { DisplayMultiplePdfs } from "../components/PdfViewer/DisplayMultiplePdfs";

function EarningsConversation() {
  const router = useHistory();
  // const { isOpen: isShareModalOpen, toggleModal: toggleShareModal } =
  //   useModal();
  const headerRef = useRef<HTMLDivElement>(null);
  const conversationRef = useRef<HTMLDivElement>(null);
  const promptsRef = useRef<HTMLDivElement>(null);
  const resultsRef = useRef<HTMLDivElement>(null);
  const [conversationId, setConversationId] = useState<string | null>(null);
  const [executionId, setExecutionId] = useState<string | null>(null);
  const [isMessagePending, setIsMessagePending] = useState(false);
  const [userMessage, setUserMessage] = useState("");
  const [selectedDocuments, setSelectedDocuments] = useState<any[]>([]);
  const [response, setResponse] = useState<response[]>([]);
  const [identifierIds, setIdentifierIds] = useState<string[]>([]);
  const { messages, userSendMessage } = useMessages(conversationId || "");
  const [isLoading, setIsLoading] = useState(false);
  // const [currentUserData, setCurrentUserData] = useState<any | null>(null);
  const [userData, setUserData] = useState<any | null>(null);
  const textFocusRef = useRef<HTMLTextAreaElement | null>(null);
  const [isConversationExpanded, setConversationExpanded] = useState(false);

  const toggleConversationExpansion = () => {
    setConversationExpanded((prev) => !prev);
  };

  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("conversationId");

  useEffect(() => {
    // router can have multiple query params which would then return string[]
    if (id && typeof id === "string") {
      setExecutionId(id);
    }
  }, [id]);

  useEffect(() => {
    // console.log("executionId- --- ", executionId);
    const fetchConversation = async (executionId: string) => {
      // const result = await backendClient.fetchConversation(executionId || "");
      const response = await axiosClient.get(
        `earningsConversation/conversation/${executionId}`
      );
      // console.log("result", response.data);

      if (response.data.documents) {
        setSelectedDocuments(response.data.documents);
      }

      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      if (response.data.userData) {
        // console.log('User Data in fetch conversation:', result.userData);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        setUserData(response.data.userData);
      }

      if (response.data.messages) {
        // console.log("result.messages: ", result.messages);

        // Flatten the array and set it as the response
        const responses = response.data.messages.flat();
        setResponse(responses);
      }
    };

    if (executionId) {
      fetchConversation(executionId).catch(() =>
        console.error("Conversation Load Error")
      );
    }
  }, [executionId]);

  // New useEffect to fetch identifierIds
  useEffect(() => {
    const fetchIdentifierIds = async (
      executionId: string | string[]
    ): Promise<void> => {
      try {
        // Convert executionId to string if it's an array
        // const executionIdString = Array.isArray(executionId)
        //   ? executionId.join(",")
        //   : executionId;

        // Make an API call to fetch identifierIds based on executionIdString
        const response = await axiosClient.get(
          `earningsExecution/identifier/${executionId}`
        );
        // console.log("response", response.data);

        // Assuming the API response is an array of string identifierIds
        setIdentifierIds(response.data);
      } catch (error) {
        console.error("Error fetching identifierIds:", error);
      }
    };

    // Fetch identifierIds when the page loads or executionId changes
    if (executionId) {
      void fetchIdentifierIds(executionId);
    }
  }, [executionId]);

  const submit = async () => {
    try {
      if (!userMessage || !executionId || !identifierIds.length) {
        return;
      }

      // const startTime = new Date().getTime();

      setIsLoading(true);

      setIsMessagePending(true);
      userSendMessage(userMessage);
      setUserMessage("");

      const currentISTTime = new Date().toLocaleString("en-US", {
        timeZone: "Asia/Kolkata",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      });

      // Create an array to store both types of responses
      const combinedResponses: response[] = [];

      // Add user's message to the combinedResponses array with a type flag "question"
      combinedResponses.push({
        type: "question",
        question: userMessage,
        time: currentISTTime,
        identifierName: "",
      });
      setResponse((prevResponses) => [
        ...prevResponses,
        {
          type: "question",
          question: userMessage,
          time: currentISTTime,
          identifierName: "",
        },
      ]);

      const promises = identifierIds.map(async (identifierId) => {
        try {
          const identifierResponse = (await axiosClient.post(
            "earningsQna",
            {
              question: userMessage,
              identifierId: identifierId,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          )) as unknown as any;

          let IdenResponse = identifierResponse.data;

          combinedResponses.push({
            ...IdenResponse,
            type: "identifier",
          });

          setResponse((prevResponses) => [
            ...prevResponses,
            { ...IdenResponse, type: "identifier" },
          ]);
          // console.log("identifierResponse: ", IdenResponse);
          // console.log("combinedResponses: ", combinedResponses);
        } catch (error) {
          console.error("Error during identifier API call:", error);
        }
      });

      try {
        await Promise.all(promises);
      } catch (error) {
        console.error("Error in parallel execution:", error);
      }

      // console.log("combinedResponses: ", combinedResponses);

      // Process combinedResponsesArray to extract required information
      const docData = combinedResponses
        .filter((response) => response.type === "identifier")
        .map((response) => ({
          qnaId: response.id || "",
          id: response.identifierName,
          text: response.response || "", // Assuming the response array contains only one item
        }));

      // console.log("docData: ", docData);

      // Additional information for the new API call
      const topics = [userMessage];

      // console.log("topics: ", topics);

      const executionIdString =
        (executionId && Array.isArray(executionId)
          ? executionId.join(",")
          : executionId) || "";

      // console.log("executionIdString: ", executionIdString);

      try {
        // Make the second API call

        const docCompResponse = (await axiosClient.post(
          "earningsDoc/comp",
          {
            docData,
            topics,
            executionId: executionIdString,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )) as unknown as any;

        const docCompResponseData = docCompResponse.data;

        // Add the docCompResponse to the array with the type flag
        combinedResponses.push({
          ...docCompResponseData,
          type: "doc-comp",
          id: "Final Result",
        });
        setResponse((prevResponses) => [
          ...prevResponses,
          {
            ...docCompResponseData,
            type: "doc-comp",
            id: "Final Result",
          },
        ]);

        // console.log("combinedResponses: ", combinedResponses);

        // const endTime = new Date().getTime();
        // const elapsedTimeInSeconds = (endTime - startTime) / 1000;
        // console.log(`Time taken in 1 QNA: ${elapsedTimeInSeconds} seconds`);
      } catch (error) {
        console.error("Error during docComparison API call:", error);
      } finally {
        setIsLoading(false);
      }

      setIsMessagePending(false);
    } catch (error) {
      console.error("Error during submission:", error);
    }
  };

  const handleTextChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setUserMessage(event.target.value);
  };
  useEffect(() => {
    const textarea = document.querySelector("textarea");
    if (textarea) {
      textarea.style.height = "auto";

      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  }, [userMessage]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Enter") {
        event.preventDefault();
        if (!isMessagePending) {
          void submit();
        }
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [submit]);

  useEffect(() => {
    const handleResize = () => {
      const viewportHeight = window.innerHeight;
      // console.log("viewportHeight", viewportHeight);
      const headerHeight = 50; // Adjust the value as per your requirements
      const conversationHeight = viewportHeight - 200; // Adjust the value as per your requirements
      const promptsHeight = 100; // Adjust the value as per your requirements
      const resultsHeight = 100; // Adjust the value as per your requirements

      if (headerRef.current) {
        headerRef.current.style.height = `${headerHeight}px`;
      }

      if (conversationRef.current) {
        conversationRef.current.style.height = `${conversationHeight}px`;
      }
      if (promptsRef.current) {
        promptsRef.current.style.height = `${promptsHeight}px`;
      }
      if (resultsRef.current) {
        resultsRef.current.style.height = `${resultsHeight}px`;
      }
    };

    handleResize(); // Set initial heights
    window.addEventListener("resize", handleResize); // Update heights on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up the event listener
    };
  }, []);

  const setSuggestedMessage = (text: string) => {
    setUserMessage(text);
    if (textFocusRef.current) {
      textFocusRef.current.focus();
    }
  };

  useEffect(() => {
    if (textFocusRef.current) {
      textFocusRef.current.focus();
    }
  }, []);

  return (
    <PdfFocusProvider>
      <div>
        <EventsListScreenHeader />
        <Container
          className="mt--7 p-0"
          fluid
          style={{ height: "calc(100vh - 100px)" }}
        >
          <Row className="m-0 h-100">
            <Col className="p-0 d-flex flex-column h-100" md={isConversationExpanded ? 12 : 6}>
              <Card className="shadow h-100">
                <Paper className="px-4 h-100 d-flex flex-column">
                  <div
                    ref={headerRef}
                    className="w-100 d-flex align-items-center justify-content-between py-3 mb-3 position-relative"
                    style={{
                      height: "80px",
                      border: "1px solid #e0e0e0",
                      borderRadius: "8px",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "#f8f9fa",
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <Button
                        onClick={() => {
                          router.push("/admin/earningsCall/historicalAnalysis");
                        }}
                        className="mr-2"
                      >
                        <BiArrowBack /> Back to Document Selection
                      </Button>
                    </div>
                    <div
                      className="position-absolute"
                      style={{ left: "50%", transform: "translateX(-50%)" }}
                    >
                      {/* <Button>
                        <div>
                          Share <FiShare className="ml-1" size={12} />
                        </div>
                      </Button> */}
                    </div>
                    <div className="d-flex align-items-center ml-auto">
                      <Button onClick={toggleConversationExpansion}>
                        <div>
                          {isConversationExpanded ? "Contract" : "Expand"}

                          {isConversationExpanded ? (
                            <BiChevronLeft className="ml-1" />
                          ) : (
                            <BiChevronRight className="ml-1" />
                          )}
                        </div>
                      </Button>
                    </div>
                  </div>

                  <div
                    ref={conversationRef}
                    className="w-100 overflow-auto bg-white p-3 mb-3 flex-grow-1"
                    style={{
                      minHeight: "200px",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <RenderConversations
                      setUserMessage={setSuggestedMessage}
                      response={response}
                    />
                  </div>

                  <div
                    className="w-100 position-relative d-flex align-items-center bg-light p-3"
                    style={{
                      height: "80px",
                      boxShadow: "0 -2px 4px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    {isLoading && (
                      <div
                        className="position-absolute d-flex align-items-center justify-content-center bg-white bg-opacity-75"
                        style={{ top: 0, left: 0, right: 0, bottom: 0 }}
                      >
                        <FetchingResults />
                      </div>
                    )}
                    <textarea
                      ref={textFocusRef}
                      className="form-control flex-grow-1 mr-2"
                      placeholder="Start typing your question..."
                      value={userMessage}
                      onChange={handleTextChange}
                      style={{
                        resize: "none",
                        height: "40px",
                        paddingRight: "40px",
                      }}
                    />
                    <Button
                    disabled={isMessagePending || userMessage.length === 0}
                    onClick={() => void submit()}
                    className="btn position-absolute"
                    style={{
                      right: "20px",
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  >
                    <BsArrowUpCircle size={24} />
                  </Button>
                  </div>
                </Paper>
              </Card>
            </Col>

            {!isConversationExpanded && (
               <Col md={6} className="d-flex flex-column p-0 h-100">
               <Card className="shadow  d-flex flex-column h-100">
                 <Paper className="px-4  d-flex flex-column h-100">
                   <h5 className="py-3">Transcripts</h5>
                   {/* Add your PDF viewer or document list here */}
                   <div className="d-flex flex-column h-100">
                 <DisplayMultiplePdfs pdfs={selectedDocuments} />
                 </div>
                 </Paper>
               </Card>
             </Col>
            )}

           
          </Row>
        </Container>
      </div>
    </PdfFocusProvider>
  );
}

export default EarningsConversation;
